export const CODE_VERIFIER_STORAGE_KEY = 'CODE_VERIFIER';
export const OAUTH_CODE_STORAGE_KEY = 'CODE';
export const OAUTH_ATTEMPT_COUNT_KEY = 'OAUTH_ATTEMPT_COUNT';
export const MAX_OAUTH_ATTEMPTS = 2;

export function isValidCodeVerifier(value: string | null | undefined): value is string {
  if (!value) {
    return false;
  }

  const normalized = value.trim();

  return normalized.length >= 43 && normalized.length <= 128;
}

export function saveCodeVerifier(codeVerifier: string): void {
  sessionStorage.setItem(CODE_VERIFIER_STORAGE_KEY, codeVerifier);
  localStorage.setItem(CODE_VERIFIER_STORAGE_KEY, codeVerifier);
}

export function getCodeVerifier(): string | null {
  const sessionVerifier = sessionStorage.getItem(CODE_VERIFIER_STORAGE_KEY);

  if (isValidCodeVerifier(sessionVerifier)) {
    return sessionVerifier;
  }

  const localVerifier = localStorage.getItem(CODE_VERIFIER_STORAGE_KEY);

  if (!isValidCodeVerifier(localVerifier)) {
    return null;
  }

  sessionStorage.setItem(CODE_VERIFIER_STORAGE_KEY, localVerifier);

  return localVerifier;
}

export function clearOAuthPkceData(): void {
  sessionStorage.removeItem(CODE_VERIFIER_STORAGE_KEY);
  sessionStorage.removeItem(OAUTH_CODE_STORAGE_KEY);
  localStorage.removeItem(CODE_VERIFIER_STORAGE_KEY);
}

export function getOAuthAttemptCount(): number {
  const value = sessionStorage.getItem(OAUTH_ATTEMPT_COUNT_KEY);
  const parsed = Number(value);

  if (!Number.isFinite(parsed) || parsed < 0) {
    return 0;
  }

  return parsed;
}

export function registerOAuthAttemptFailure(): number {
  const nextCount = getOAuthAttemptCount() + 1;
  sessionStorage.setItem(OAUTH_ATTEMPT_COUNT_KEY, String(nextCount));

  return nextCount;
}

export function resetOAuthAttemptCount(): void {
  sessionStorage.removeItem(OAUTH_ATTEMPT_COUNT_KEY);
}

export function canRetryOAuth(): boolean {
  return getOAuthAttemptCount() < MAX_OAUTH_ATTEMPTS;
}
